import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import KNCountryFlag from 'components/KNCountryFlag/KNCountryFlag'
import { zonedDate } from 'global/helpers/dates'
import { replaceHighlights } from 'global/helpers/highlights'
import type { ReactElement } from 'react'
import type { TripData } from './TripDashboard.types'

interface TripDatesProps {
  trip: Pick<TripData,
    'earlyPickUpDate' | 'lateDeliveryDate' | 'countryCodePickUpPlace' | 'pickUpPlace'
    | 'countryCodeDeliveryPlace' | 'deliveryPlace'>
  keywords?: string[]
}

const formatLocation = (countryCode?: string | null, place?: string | null): string =>
  [countryCode, place].filter(Boolean).join(', ') || '—'

const TripDates = ({ trip, keywords }: TripDatesProps): ReactElement => (
  <Grid container spacing={2}>
    <Grid size={{ xs: 6 }}>
      <Typography variant="p3" noWrap>{zonedDate(trip.earlyPickUpDate ?? null, 'full_no_year') ?? '—'}</Typography>
      <Typography component="p" variant="p3" color="primary.main" noWrap>
        {trip.countryCodePickUpPlace && <KNCountryFlag countryCode={trip.countryCodePickUpPlace} />}
        {replaceHighlights(formatLocation(trip.countryCodePickUpPlace, trip.pickUpPlace), keywords)}
      </Typography>
    </Grid>
    <Grid size={{ xs: 6 }}>
      <Typography variant="p3" noWrap>{zonedDate(trip.lateDeliveryDate ?? null, 'full_no_year') ?? '—'}</Typography>
      <Typography component="p" variant="p3" color="primary.main" noWrap>
        {trip.countryCodeDeliveryPlace && <KNCountryFlag countryCode={trip.countryCodeDeliveryPlace} />}
        {replaceHighlights(formatLocation(trip.countryCodeDeliveryPlace, trip.deliveryPlace), keywords)}
      </Typography>
    </Grid>
  </Grid>
)

export default TripDates
